// builders/EnclosureInitializer.js
import { v4 as uuidv4 } from "uuid";
import { resolveDuctArticle } from "./dummyDucts";

export async function buildEnclosureFromSettings(
  projectId,
  enclosure,
  settings,
) {
  // One lookup for all three enclosure ducts. Never null: falls back to a
  // placeholder duct when nothing is selected or the duct was deleted.
  const article = await resolveDuctArticle(settings?.ductsEnclosureId, "enclosure");

  const plateHeight =
    enclosure?.montagePlacement?.size?.height ?? enclosure?.size?.height ?? 0;
  const plateWidth =
    enclosure?.montagePlacement?.size?.width ?? enclosure?.size?.width ?? 0;

  // -----------------------------
  // LEFT / RIGHT DUCT
  // -----------------------------
  function createVerticalDuct() {
    const width = article.size?.width || 0;
    const depth = article.size?.depth || 40;

    return {
      id: uuidv4(),
      parentId: enclosure.id,
      referenceId: article.id, // EMPTY_GUID for the placeholder
      position: { x: 0, y: 0 },
      size: { width, height: plateHeight - width, depth }, // original formula
    };
  }

  // -----------------------------
  // TOP DUCT
  // -----------------------------
  function createTopDuct() {
    return {
      id: uuidv4(),
      parentId: enclosure.id,
      referenceId: article.id,
      position: { x: 0, y: 0 },
      size: {
        width: Math.max(plateWidth, 0),
        height: article.size?.width ?? 0,
        depth: article.size?.depth ?? 40,
      },
    };
  }

  enclosure.ductLeft = createVerticalDuct();
  enclosure.ductRight = createVerticalDuct();
  enclosure.ductTop = createTopDuct();
  return enclosure;
}
